import { createReducer } from '@reduxjs/toolkit';
import { SET_SUCCESS_MESSAGE, SET_IS_SENDING } from '../actions/RecomendeAction';

const initialState = {
    successMessage: false,
    isSending: false,
};

const recomende = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_SUCCESS_MESSAGE, (state, action) => {
            state.successMessage = action.success;
        })
        .addCase(SET_IS_SENDING, (state, action) => {
            state.isSending = action.isSending;
        });
});

export default recomende;
